import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "bootstrap";
import "jquery";
import "vuelidate";
import "validators";
import "sortablejs";
import "vuedraggable";

//import $ from "expose-loader?exposes=$,jQuery!jquery";

Vue.config.productionTip = false;
Vue.config.devtools = true;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

//console.log(app.$store.state.answers);
//console.log(app);
